import { message } from 'antd';
import { useModel } from '@umijs/max';
import { ACTION_CONTROL } from '@/constants/action-permission';

/**
 * 权限控制Hook
 * 提供权限检查和权限按钮点击处理功能
 */
export function usePermissionControl() {
  const { initialState } = useModel('@@initialState');
  const loginUser = initialState?.currentUser;

  /**
   * 检查是否有指定权限
   * @param permissionKey 权限键值，来自ACTION_CONTROL
   * @returns 是否有权限
   */
  const hasPermission = (permissionKey: ACTION_CONTROL): boolean => {
    const roleData = loginUser?.role_data;
    const menuCodes = roleData?.menu_codes || [];

    // 商家管理员可以访问所有页面
    if (loginUser?.isAdmin) {
      return true;
    }

    // 判断是否在角色权限中
    if (menuCodes.includes(permissionKey)) {
      return true;
    }

    return false;
  };

  /**
   * 权限按钮点击处理函数
   * @param permissionKey 权限键值
   * @param callback 有权限时的回调函数
   * @param errorMessage 无权限时的提示信息
   */
  const handlePermissionClick = (permissionKey: ACTION_CONTROL, callback: () => void) => {
    if (hasPermission(permissionKey)) {
      callback();
    } else {
      message.warning('无操作权限，请联系商家管理员');
    }
  };

  return {
    hasPermission,
    handlePermissionClick,
  };
}
